import {RouteRecordRaw, createRouter, createWebHistory} from 'vue-router'  

const routes: Array<RouteRecordRaw>= [
    {
        path: '/',
        name: 'Root',
        component: () => import(/* webpackChunkName: "about" */ './views/AboutView.vue')
      },
      {
        path: '/resume',
        name: 'Resume',
        component: () => import(/* webpackChunkName: "about" */ './views/ResumeView.vue')
      },
      {
        path: '/game-projects',
        name: 'Game Projects',
        component: () => import(/* webpackChunkName: "about" */ './views/GameProjects.vue')
      },
      {
        path: '/art-projects',
        name: 'Art Projects',
        component: () => import(/* webpackChunkName: "about" */ './views/ArtProjects.vue')
      },
      {
        path: '/tool-projects',
        name: 'Tool Projects',
        component: () => import(/* webpackChunkName: "about" */ './views/ToolProjects.vue')
      },
      {
        path: '/contact',
        name: 'Contact',
        component: () => import(/* webpackChunkName: "about" */ './views/ContactView.vue')
      },
      {
        path: '/404',
        name: 'NotFound',
        component: () => import(/* webpackChunkName: "about" */ './views/404View.vue')
      },
      { 
        path: '/:pathMatch(.*)*', 
        name: 'not-found',  
        component: () => import(/* webpackChunkName: "about" */ './views/404View.vue') 
      },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router;